import { useState, useEffect } from 'react';
import { FileObject } from '../Utils/uploadUtils/UploadUtils';

export const useFilePreview = (file: FileObject) => {
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    useEffect(() => {
        // If we have a previewUrl (from converted file or link), use it
        if (file.previewUrl) {
            setPreviewUrl(file.previewUrl);
            return;
        }

        // For files that need URL.createObjectURL
        if (!file.originalFile || !file.type || !['image', 'gif', 'video'].includes(file.type)) {
            setPreviewUrl(null);
            return;
        }

        // Create new preview URL from original file
        const url = URL.createObjectURL(file.originalFile);
        setPreviewUrl(url);

        // Cleanup function to revoke the URL when component unmounts or file changes
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [file.originalFile, file.type, file.previewUrl]);

    return previewUrl;
};